"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAVORITE_LISTS_RECEIVER_PAGE = exports.FAVORITE_LISTS_LANDING_PAGE = void 0;
// istanbul ignore file -- constants */
const FAVORITE_LISTS_LANDING_PAGE = exports.FAVORITE_LISTS_LANDING_PAGE = '/favourite-lists/';
const FAVORITE_LISTS_RECEIVER_PAGE = exports.FAVORITE_LISTS_RECEIVER_PAGE = '/shared-list/';
